import { http, getRouteParams } from '../api';
import parser from '../parser';
import Translations from '../services/translations';

export default {
  FETCH_META({ commit, getters: { companySettings } }, dateParams) {
    http
      .get('/getMeta', {
        params: getRouteParams(companySettings, dateParams),
      })
      .then(response => commit('SAVE_METADATA', parser.formatMeta(response.data)));
  },
  FETCH_RESULTS({ commit, getters: { companySettings } }, dateParams) {
    http
      .get('/getResults', {
        params: getRouteParams(companySettings, dateParams),
      })
      .then((response) => {
        commit('SAVE_MATCHESDATA', parser.formatResults(response.data));
        commit('SAVE_METADATA', parser.formatMeta(response.data));
        commit('SELECT_SPORT');
        commit('FILTER_RESULTS');
      });
  },
  SELECT_SPORT({ commit }, sport) {
    commit('SELECT_SPORT', sport);
  },
  FILTER_SELECTION({ commit }) {
    commit('FILTER_RESULTS');
  },
  SAVE_DATE({ commit }, utcDate) {
    commit('SAVE_DATE', utcDate);
  },
  FETCH_TRANSLATIONS({ commit }) {
    Translations.fetch()
      .then((response) => {
        commit('SAVE_TRANSLATIONS', response);
      });
  },
  SAVE_COMPANY_SETTINGS({ commit }, payload) {
    commit('SAVE_COMPANY_SETTINGS', payload);
  },
};
